

export class AttnCountModel {
    date: string;
    totalCount: number;
    presentCount: number;


    constructor(date: string, totalCount: number, presentCount: number) {
        this.date = date;
        this.totalCount = totalCount;
        this.presentCount = presentCount;

    }
}